module.exports = __webpack_public_path__ + "img/user-icon.c5bab3c3.svg";